<template>
  <el-input
    v-if="filter"
    style="padding-bottom: 15px"
    :model-value="filterValue"
    :placeholder="placeholder"
    @input="onChangeVal"
  />
  <el-tree-v2
    ref="treeRef"
    :class="['cig-tree', $attrs.class]"
    v-bind="{ ...defaultProp, ...$attrs, filterMethod: filterMethodFunc }"
  >
    <template v-if="$slots.default" #default="{ node, data }">
      <slot :node="node" :data="data" />
    </template>
  </el-tree-v2>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import { ElTreeV2 } from '@park-ui/components/tree-v2'
import { ElInput } from '@park-ui/components/input'
import { treeCustomProps, treeDefaultProps } from './tree/defaults'
import type { TreeData } from '../../tree-v2/src/types'
export default defineComponent({
  name: 'ElCigTree',
  components: {
    ElInput,
    ElTreeV2,
  },
  props: {
    ...treeDefaultProps,
    ...treeCustomProps,
  },
  emits: ['update:filterValue'],
  setup(props, { emit, expose }) {
    // init here
    const defaultProp = props
    const treeRef = ref<InstanceType<typeof ElTreeV2>>()
    function onChangeVal(value: string) {
      emit('update:filterValue', value)
      // TODO: fix typing when refactor tree-v2
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      treeRef.value!.filter(value)
    }
    function setData(data: TreeData) {
      // TODO: fix typing when refactor tree-v2
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      treeRef.value!.setData(data)
    }
    // 默认过滤函数
    function filterMethod(query: string, node: any) {
      if (!query) return true
      const labelKey: string = defaultProp.props.label!
      return node[labelKey].includes(query)
    }
    const filterMethodFunc = defaultProp.filterMethod || filterMethod
    expose({
      setData,
    })
    return {
      treeRef,
      defaultProp,
      filterMethodFunc,
      onChangeVal,
    }
  },
})
</script>
